import React from "react";
import {
  ButtonSizes,
  ButtonVariants,
  Button
} from "@certa/catalyst/components/Button";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@certa/catalyst/components/Dropdown";

import { useCreateNewWorkflow } from "../../hooks/useCreateNewWorkflow";
import { Book } from "@certa/icons/components/Book";
import { QuestionFilled } from "@certa/icons/components/QuestionFilled";
import { CERTA_SUPPORT } from "../../constants";
import { analyticsService, AnalyticsEvents } from "@certa/analytics";
import type { DropdownOption } from "@certa/common/hooks/useFilterHeaderOptionBasedOnUserGroup";

type CreateCertaSupportDropdownProps = {
  dropdownOptions?: DropdownOption[];
  supportTicketData?: DropdownOption | null;
};

export const CreateCertaSupportDropdown = (
  props: CreateCertaSupportDropdownProps
) => {
  const { onSelect } = useCreateNewWorkflow();
  return (
    <DropdownMenu
      onOpenChange={open => {
        open &&
          analyticsService.track(
            AnalyticsEvents.headerEvents.HEADER_CLICK_HELP_DROPDOWN
          );
      }}
    >
      <DropdownMenuTrigger>
        <Button
          size={ButtonSizes.SMALL}
          variant={ButtonVariants.LINK}
          leftIcon={<QuestionFilled />}
          showDropdownArrow={true}
        >
          Help
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <>
          {props?.supportTicketData && (
            <DropdownMenuGroup
              hasSeparator={(props?.dropdownOptions || []).length > 0}
            >
              <DropdownMenuItem value={CERTA_SUPPORT} onSelect={onSelect}>
                <Book />
                {props?.supportTicketData.label}
              </DropdownMenuItem>
            </DropdownMenuGroup>
          )}
          {props?.dropdownOptions?.map(
            (option: DropdownOption, index: number) => (
              <DropdownMenuItem
                key={index}
                value={option?.url || ""}
                onSelect={window.open}
              >
                {option.label}
              </DropdownMenuItem>
            )
          )}
        </>
      </DropdownMenuContent>
    </DropdownMenu>
  );
  // }
};
